import {
  title_default
} from "./chunk-L2AFJ2KW.js";

// src/blocks/title/index.ts
var title_default2 = title_default;

export {
  title_default2 as title_default
};
